var map = {
	"./": [
		322,
		9
	],
	"./Results.dictionaty": [
		347,
		3
	],
	"./Results.dictionaty.json": [
		347,
		3
	],
	"./Results.explanation": [
		1171,
		9,
		149
	],
	"./Results.explanation.ts": [
		1171,
		9,
		149
	],
	"./Results.module.scss": [
		1172,
		9,
		293
	],
	"./ResultsPage": [
		1173,
		9,
		9,
		12,
		150
	],
	"./ResultsPage.tsx": [
		1173,
		9,
		9,
		12,
		150
	],
	"./ResultsPageDeferred": [
		380,
		9
	],
	"./ResultsPageDeferred.tsx": [
		380,
		9
	],
	"./actions": [
		334,
		9
	],
	"./actions.ts": [
		334,
		9
	],
	"./components/Filters": [
		1030,
		9,
		9,
		12,
		44
	],
	"./components/Filters/": [
		1030,
		9,
		9,
		12,
		44
	],
	"./components/Filters/ButtonBar": [
		953,
		9,
		45
	],
	"./components/Filters/ButtonBar/": [
		953,
		9,
		45
	],
	"./components/Filters/ButtonBar/ButtonBar.module.scss": [
		1069,
		9,
		298
	],
	"./components/Filters/ButtonBar/index": [
		953,
		9,
		45
	],
	"./components/Filters/ButtonBar/index.tsx": [
		953,
		9,
		45
	],
	"./components/Filters/DatePick": [
		1008,
		9,
		9,
		46
	],
	"./components/Filters/DatePick/": [
		1008,
		9,
		9,
		46
	],
	"./components/Filters/DatePick/DatePick.module.scss": [
		1094,
		9,
		299
	],
	"./components/Filters/DatePick/index": [
		1008,
		9,
		9,
		46
	],
	"./components/Filters/DatePick/index.tsx": [
		1008,
		9,
		9,
		46
	],
	"./components/Filters/DatePick/types": [
		1175,
		7,
		171
	],
	"./components/Filters/DatePick/types.ts": [
		1175,
		7,
		171
	],
	"./components/Filters/Filter.module.scss": [
		1174,
		9,
		300
	],
	"./components/Filters/Filters.dictionary": [
		1098,
		3,
		172
	],
	"./components/Filters/Filters.dictionary.json": [
		1098,
		3,
		172
	],
	"./components/Filters/Search": [
		1009,
		9,
		47
	],
	"./components/Filters/Search/": [
		1009,
		9,
		47
	],
	"./components/Filters/Search/Search.dictionary": [
		1066,
		3,
		173
	],
	"./components/Filters/Search/Search.dictionary.json": [
		1066,
		3,
		173
	],
	"./components/Filters/Search/Search.module.scss": [
		1095,
		9,
		301
	],
	"./components/Filters/Search/index": [
		1009,
		9,
		47
	],
	"./components/Filters/Search/index.tsx": [
		1009,
		9,
		47
	],
	"./components/Filters/Sorts": [
		1010,
		9,
		48
	],
	"./components/Filters/Sorts/": [
		1010,
		9,
		48
	],
	"./components/Filters/Sorts/Sorts.dictionary": [
		1067,
		3,
		174
	],
	"./components/Filters/Sorts/Sorts.dictionary.json": [
		1067,
		3,
		174
	],
	"./components/Filters/Sorts/Sorts.module.scss": [
		1096,
		9,
		302
	],
	"./components/Filters/Sorts/index": [
		1010,
		9,
		48
	],
	"./components/Filters/Sorts/index.tsx": [
		1010,
		9,
		48
	],
	"./components/Filters/SportsList": [
		1011,
		9,
		49
	],
	"./components/Filters/SportsList/": [
		1011,
		9,
		49
	],
	"./components/Filters/SportsList/SportsList.module.scss": [
		1097,
		9,
		303
	],
	"./components/Filters/SportsList/index": [
		1011,
		9,
		49
	],
	"./components/Filters/SportsList/index.tsx": [
		1011,
		9,
		49
	],
	"./components/Filters/index": [
		1030,
		9,
		9,
		12,
		44
	],
	"./components/Filters/index.tsx": [
		1030,
		9,
		9,
		12,
		44
	],
	"./components/Tables": [
		1013,
		9,
		70
	],
	"./components/Tables/": [
		1013,
		9,
		70
	],
	"./components/Tables/Table": [
		954,
		9,
		71
	],
	"./components/Tables/Table/": [
		954,
		9,
		71
	],
	"./components/Tables/Table/Header": [
		919,
		9,
		72
	],
	"./components/Tables/Table/Header/": [
		919,
		9,
		72
	],
	"./components/Tables/Table/Header/Header.dictionary": [
		955,
		3,
		218
	],
	"./components/Tables/Table/Header/Header.dictionary.json": [
		955,
		3,
		218
	],
	"./components/Tables/Table/Header/Header.module.scss": [
		1014,
		9,
		321
	],
	"./components/Tables/Table/Header/index": [
		919,
		9,
		72
	],
	"./components/Tables/Table/Header/index.tsx": [
		919,
		9,
		72
	],
	"./components/Tables/Table/Match": [
		920,
		9,
		73
	],
	"./components/Tables/Table/Match/": [
		920,
		9,
		73
	],
	"./components/Tables/Table/Match/Match.module.scss": [
		1015,
		9,
		322
	],
	"./components/Tables/Table/Match/index": [
		920,
		9,
		73
	],
	"./components/Tables/Table/Match/index.tsx": [
		920,
		9,
		73
	],
	"./components/Tables/Table/Table.dictionary": [
		1016,
		3,
		219
	],
	"./components/Tables/Table/Table.dictionary.json": [
		1016,
		3,
		219
	],
	"./components/Tables/Table/Table.module.scss": [
		1070,
		9,
		323
	],
	"./components/Tables/Table/index": [
		954,
		9,
		71
	],
	"./components/Tables/Table/index.tsx": [
		954,
		9,
		71
	],
	"./components/Tables/Tables.dictionary": [
		1071,
		3,
		220
	],
	"./components/Tables/Tables.dictionary.json": [
		1071,
		3,
		220
	],
	"./components/Tables/Tables.module.scss": [
		1099,
		9,
		324
	],
	"./components/Tables/index": [
		1013,
		9,
		70
	],
	"./components/Tables/index.tsx": [
		1013,
		9,
		70
	],
	"./constants": [
		836,
		9,
		256
	],
	"./constants.ts": [
		836,
		9,
		256
	],
	"./index": [
		322,
		9
	],
	"./index.tsx": [
		322,
		9
	],
	"./reducer": [
		356,
		9
	],
	"./reducer.ts": [
		356,
		9
	],
	"./types": [
		1118,
		7,
		334
	],
	"./types.ts": [
		1118,
		7,
		335
	],
	"./utils/getScores": [
		956,
		9,
		262
	],
	"./utils/getScores.ts": [
		956,
		9,
		262
	],
	"./utils/sort": [
		1012,
		9,
		263
	],
	"./utils/sort.ts": [
		1012,
		9,
		263
	],
	"./utils/sportsList": [
		1068,
		9,
		264
	],
	"./utils/sportsList.ts": [
		1068,
		9,
		264
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1286;
module.exports = webpackAsyncContext;